//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';
import {Request} from '../../../../../types/esgi.students/features/esgi.districtadmin/classes/delete/request';
import {BaseResponse} from '../../../../../types/esgi.app/endpoints/abstractions/base-response';

export function classesDelete(httpClient: ContractHttpClient) {
	return (inModel: Request): Observable<BaseResponse> => {
		return httpClient.request<BaseResponse>(
			'POST',
			'/v2/district-admins/action-panel/classes/delete',
			inModel,
		).asObservable();
	};
}
